import { arrayUnique } from './array.util';
export function capitalize(str) {
    return str ? str[0].toUpperCase() + str.substring(1) : str;
}
export function apiQueryContains(term) {
    if (term) {
        return { $ilike: `%${term}%` };
    }
    else {
        return undefined;
    }
}
export function firstLetters(str) {
    return str
        .split(' ')
        .map((word) => word[0])
        .join('');
}
export function arrayToStringWithCountInfo(items) {
    const uniqueItems = items.filter(arrayUnique);
    return uniqueItems.map((text) => `${items.filter((x) => x == text).length}x ${text}`).join(', ');
}
//# sourceMappingURL=strings.util.js.map